import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-youjian",
  "use": "icon-youjian-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"design-iconfont\" id=\"icon-youjian\">\n  <g transform=\"translate(2 4.5)\" stroke=\"#0F0629\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.75\" fill=\"none\" fill-rule=\"evenodd\">\n    <rect width=\"20\" height=\"15\" rx=\"2\" />\n    <path d=\"M0,2.5 L9.22825637,8.03695382 C9.70327995,8.32196797 10.2967201,8.32196797 10.7717436,8.03695382 L20,2.5 L20,2.5\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol